import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs';

import { AdobePageData } from 'app/models/adobe.model';
//import { Cookie } from 'ng2-cookies/ng2-cookies';


@Injectable()
export class AdobeServiceServer {

   

      constructor() {
            
      }
      /**
      *  This is a public method exposed to set page level data to be passed to site catalyst.
      *   
       */
      public setSCPageData(eventType: String, pageData: AdobePageData, eventObject?: any) {

           
      }

      public attachFormSCEvents(pageData): any {
          
      }
      public attachEvents(inputs, pageData): void {

     
      }
}
